import React from 'react';

import { useIntl } from 'react-intl';
import { View } from 'react-native';

import BlockRenderer from 'components/sanity-block-renderer';
import { useProductWizardContext } from 'state/product-wizard-v2';

import {
  ProductInformationContainer,
  ProductInformationTextProps,
  ProductInformationTitle,
} from './styled';

export const ProductInformation: React.FC = () => {
  const { formatMessage } = useIntl();
  const { selectedProduct } = useProductWizardContext();

  if (!selectedProduct.description?.localeRaw) {
    return null;
  }

  const title = formatMessage({ id: 'productInformation' });

  // Create a unique identifier for the description
  const contentKey = `${selectedProduct._id}-${selectedProduct.description.localeRaw[0]?._key}`;

  return (
    <ProductInformationContainer testID="product-information-container">
      <ProductInformationTitle accessibilityRole="header" accessibilityLevel={5}>
        {title}
      </ProductInformationTitle>
      <View key={contentKey} collapsable={false}>
        <BlockRenderer
          content={selectedProduct.description.localeRaw}
          textProps={ProductInformationTextProps}
        />
      </View>
    </ProductInformationContainer>
  );
};
